export const MRT_Localization_HI = {
    actions: "क्रियाएं",
    and: "और",
    cancel: "रद्द करें",
    changeFilterMode: "फ़िल्टर मोड बदलें",
    changeSearchMode: "खोज मोड बदलें",
    clearFilter: "फ़िल्टर हटाएं",
    clearSearch: "खोज हटाएं",
    clearSelection: "चयन हटाएं",
    clearSort: "क्रम हटाएं",
    clickToCopy: "कॉपी करने के लिए क्लिक करें",
    copy: "कॉपी करें",
    collapse: "संकुचित करें",
    collapseAll: "सभी संकुचित करें",
    columnActions: "कॉलम क्रियाएं",
    copiedToClipboard: "क्लिपबोर्ड पर कॉपी किया गया",
    dropToGroupBy: "{column} से समूहबद्ध करने के लिए छोड़ें",
    edit: "संपादित करें",
    expand: "विस्तारित करें",
    expandAll: "सभी विस्तारित करें",
    filterArrIncludes: "शामिल हैं",
    filterArrIncludesAll: "सभी शामिल हैं",
    filterArrIncludesSome: "कुछ शामिल हैं",
    filterBetween: "के बीच",
    filterBetweenInclusive: "सम्मिलित रूप से बीच में",
    filterByColumn: "{column} द्वारा फ़िल्टर करें",
    filterContains: "शामिल करता है",
    filterEmpty: "खाली",
    filterEndsWith: "के साथ समाप्त होता है",
    filterEquals: "बराबर है",
    filterEqualsString: "बराबर है",
    filterFuzzy: "अनुमानित",
    filterGreaterThan: "से अधिक",
    filterGreaterThanOrEqualTo: "के बराबर या अधिक",
    filterInNumberRange: "सीमा के भीतर",
    filterIncludesString: "शामिल करता है",
    filterIncludesStringSensitive: "संवेदनशील रूप से शामिल करता है",
    filterLessThan: "से कम",
    filterLessThanOrEqualTo: "के बराबर या कम",
    filterMode: "फ़िल्टर मोड: {filterType}",
    filterNotEmpty: "खाली नहीं",
    filterNotEquals: "बराबर नहीं",
    filterStartsWith: "से शुरू होता है",
    filterWeakEquals: "बराबर",
    filteringByColumn: "{column} द्वारा फ़िल्टर किया जा रहा है - {filterType} {filterValue}",
    goToFirstPage: "पहले पृष्ठ पर जाएं",
    goToLastPage: "अंतिम पृष्ठ पर जाएं",
    goToNextPage: "अगले पृष्ठ पर जाएं",
    goToPreviousPage: "पिछले पृष्ठ पर जाएं",
    grab: "पकड़ें",
    groupByColumn: "{column} द्वारा समूहित करें",
    groupedBy: "द्वारा समूहित किया गया",
    hideAll: "सभी छुपाएं",
    hideColumn: "{column} कॉलम छुपाएं",
    max: "अधिकतम",
    min: "न्यूनतम",
    move: "स्थानांतरित करें",
    noRecordsToDisplay: "प्रदर्शित करने के लिए कोई रिकॉर्ड नहीं",
    noResultsFound: "कोई परिणाम नहीं मिला",
    of: "का",
    or: "या",
    pin: "पिन करें",
    pinToLeft: "बाएँ पिन करें",
    pinToRight: "दाएँ पिन करें",
    resetColumnSize: "कॉलम आकार रीसेट करें",
    resetOrder: "क्रम रीसेट करें",
    rowActions: "पंक्ति क्रियाएं",
    rowNumber: "#",
    rowNumbers: "पंक्ति संख्याएं",
    rowsPerPage: "प्रति पृष्ठ पंक्तियाँ",
    save: "सहेजें",
    search: "खोजें",
    selectedCountOfRowCountRowsSelected: "{rowCount} में से {selectedCount} पंक्तियाँ चयनित",
    select: "चयन करें",
    showAll: "सभी दिखाएं",
    showAllColumns: "सभी कॉलम दिखाएं",
    showHideColumns: "कॉलम दिखाएं/छुपाएं",
    showHideFilters: "फ़िल्टर दिखाएं/छुपाएं",
    showHideSearch: "खोज दिखाएं/छुपाएं",
    sortByColumnAsc: "{column} को आरोही क्रम में छांटें",
    sortByColumnDesc: "{column} को अवरोही क्रम में छांटें",
    sortedByColumnAsc: "{column} द्वारा आरोही क्रम में छांटा गया",
    sortedByColumnDesc: "{column} द्वारा अवरोही क्रम में छांटा गया",
    thenBy: ", फिर ",
    toggleDensity: "घनत्व टॉगल करें",
    toggleFullScreen: "पूर्ण स्क्रीन टॉगल करें",
    toggleSelectAll: "सभी चयन टॉगल करें",
    toggleSelectRow: "पंक्ति चयन टॉगल करें",
    toggleVisibility: "दृश्यता टॉगल करें",
    ungroupByColumn: "{column} से समूह हटाएं",
    unpin: "अनपिन करें",
    unpinAll: "सभी अनपिन करें",
};
